module.exports = __webpack_public_path__ + "cfb55de56ccbae7818f5667148e61532.jpg";